import { Box, Tooltip, Badge, Typography } from '@mui/material';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import useSellerAgent from './useSellerAgent';
import SellerChatPanel from './SellerChatPanel';

export default function SellerChatWidget() {
  const { messages, isOpen, isTyping, pageContext, sendMessage, openChat, closeChat, clearChat } =
    useSellerAgent();

  const unread = !isOpen && messages.length > 0;

  return (
    <Box>
      {isOpen && (
        <SellerChatPanel
          messages={messages}
          isTyping={isTyping}
          pageContext={pageContext}
          onSend={sendMessage}
          onClose={closeChat}
          onClear={clearChat}
        />
      )}

      {!isOpen && (
        <Tooltip title="Ask AIR — AI Assistant" placement="left">
          <Badge color="error" variant="dot" invisible={!unread} overlap="circular">
            <Box
              component="button"
              type="button"
              onClick={openChat}
              aria-label="Open AI Assistant"
              sx={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                zIndex: 1400,
                height: 56,
                maxWidth: 56,
                borderRadius: 999,
                border: 'none',
                cursor: 'pointer',
                px: 1.75,
                display: 'inline-flex',
                alignItems: 'center',
                overflow: 'hidden',
                color: '#fff',
                background: 'linear-gradient(90deg, #4500f9 0%, #5b21ff 50%, #cd83ff 100%)',
                boxShadow: '0 10px 28px rgba(69, 0, 249, 0.4)',
                transition: 'max-width 0.3s ease, box-shadow 0.3s ease, transform 0.2s ease',
                '@keyframes airFabRing': {
                  '0%': { transform: 'scale(1)', opacity: 0.5 },
                  '70%': { transform: 'scale(1.55)', opacity: 0 },
                  '100%': { transform: 'scale(1.55)', opacity: 0 },
                },
                '@keyframes airFabFloat': {
                  '0%, 100%': { transform: 'translateY(0)' },
                  '50%': { transform: 'translateY(-5px)' },
                },
                animation: 'airFabFloat 3.2s ease-in-out infinite',
                '&::before, &::after': {
                  content: '""',
                  position: 'absolute',
                  inset: 0,
                  borderRadius: '999px',
                  background: 'rgba(69, 0, 249, 0.3)',
                  zIndex: -1,
                  pointerEvents: 'none',
                },
                '&::before': {
                  animation: 'airFabRing 2.4s cubic-bezier(0.22, 1, 0.36, 1) infinite',
                },
                '&::after': {
                  background: 'rgba(205, 131, 255, 0.28)',
                  animation: 'airFabRing 2.4s cubic-bezier(0.22, 1, 0.36, 1) 0.7s infinite',
                },
                '&:hover': {
                  maxWidth: 180,
                  animation: 'none',
                  transform: 'translateY(0)',
                  boxShadow: '0 14px 36px rgba(69, 0, 249, 0.5)',
                  '& .air-fab-label': {
                    maxWidth: 110,
                    opacity: 1,
                    ml: 1.25,
                  },
                },
              }}
            >
              <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32 }}>
                <ChatBubbleOutlineRoundedIcon sx={{ fontSize: 20 }} />
                <Box
                  sx={{
                    position: 'absolute',
                    top: -1,
                    right: -1,
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    bgcolor: '#34d399',
                    border: '2px solid #4500f9',
                    boxShadow: '0 0 8px rgba(52, 211, 153, 0.8)',
                  }}
                />
              </Box>
              <Typography
                className="air-fab-label"
                component="span"
                sx={{
                  ml: 0,
                  maxWidth: 0,
                  opacity: 0,
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  fontSize: 14,
                  fontWeight: 600,
                  letterSpacing: '0.02em',
                  transition: 'all 0.3s ease',
                }}
              >
                Ask AIR
              </Typography>
            </Box>
          </Badge>
        </Tooltip>
      )}
    </Box>
  );
}
